import { Link } from 'react-router-dom';
import './UnitedNations.css';

function UnitedNations({ siteData }) {
  const unitedNations = siteData?.unitedNations || {};

  return (
    <div className="page-shell un-page">
      <div className="page-intro un-hero" style={{ marginBottom: '36px' }}>
        <span className="un-pill">Global Cooperation</span>
        <h1 className="page-title">{unitedNations.heading || 'United Nations Initiatives'}</h1>
        <p className="page-subtitle">
          {unitedNations.intro || 'We share information on global peace education, human rights, and SDG-focused development strategies with a strong commitment to international cooperation.'}
        </p>
      </div>

      {/* Featured UN Initiatives Quick Links */}
      <section className="un-initiatives-section" style={{ marginTop: '0' }}>
        <h2 className="un-section-title">Key UN Portals & Initiatives</h2>
        <p className="un-section-desc">
          Explore our dedicated initiatives, universal human rights documentation, and global peace academic frameworks.
        </p>

        <div className="un-links-grid">
          <Link to="/united-nations/sdg-interactive" className="un-link-card">
            <span className="un-card-badge">UN Agenda 2030</span>
            <h3>SDG Interactive</h3>
            <p>Explore the 17 Sustainable Development Goals and UNGDO's global targets.</p>
            <span className="un-card-btn">Explore Goals →</span>
          </Link>

          <Link to="/united-nations/un-human-rights-declaration" className="un-link-card">
            <span className="un-card-badge">Proclaimed 1948</span>
            <h3>UN Human Rights Declaration</h3>
            <p>Universal standards of fundamental human rights protected for all peoples.</p>
            <span className="un-card-btn">Read Declaration →</span>
          </Link>

          <Link to="/united-nations/un-university-for-global-peace" className="un-link-card">
            <span className="un-card-badge">Academic & Peace</span>
            <h3>UN University for Global Peace</h3>
            <p>Higher education, peace symposia, and global diplomacy programs.</p>
            <span className="un-card-btn">Learn More →</span>
          </Link>
        </div>
      </section>
    </div>
  );
}

export default UnitedNations;
